import React from "react";
import { empowerBand } from "../mock";
import Reveal from "./Reveal";

const EmpowerBand = () => {
  return (
    <section id="kid-of-the-week" className="bg-white py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <Reveal>
          <h2 className="font-display text-center text-3xl md:text-5xl mb-10" style={{ color: "#187EE4" }}>
            Your kid &ndash; strong, calm<br />and ready for what&rsquo;s going on!
          </h2>
        </Reveal>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {empowerBand.images.map((img, i) => (
            <Reveal key={img} delay={i * 90}>
              <div className="group relative rounded-3xl overflow-hidden shadow-md aspect-[4/5]">
                <img
                  src={img}
                  alt="Brave kid"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div
                  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity"
                  style={{ background: "linear-gradient(to top, rgba(24,126,228,0.55), transparent 60%)" }}
                />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EmpowerBand;
